export const DEPLOYMENT_URL = `/api/agent/deployments`;
